import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { Button } from 'ui-components/components/button';
import UserDateFormat from '../../../../components/user-date-format/index';
import UserTimeFormat from '../../../../components/user-time-format/connected';
import { getStoreActivity } from '../../api/store-api';
import messages from './messages';

import style from './style.module.less';

const NUMBER_OF_ACTIVITY_EVENTS_TO_LOAD = 5;

const ActivityInstance = ({ instance }) => {
  const { dateTime, username, message } = instance;
  return (
    <div className={style.instance}>
      <div className={style['instance-line']}>
        <div className={style.time}>
          <FontAwesomeIcon className={style['clock-icon']} icon={faClock} />
          <FormattedMessage
            {...messages.activityMetadata}
            values={{
              date: <UserDateFormat value={dateTime} />,
              time: <UserTimeFormat value={dateTime} />,
            }}
          />
        </div>
        <FontAwesomeIcon className={style['person-icon']} icon={faUser} />
        {username}
      </div>
      <div className={style['bottom-instance-line']}>{message}</div>
    </div>
  );
};

ActivityInstance.propTypes = {
  instance: PropTypes.object.isRequired,
};

const ActivityTab = ({ storeGuid }) => {
  const [activity, setActivity] = useAsyncSafeState([]);
  const [skipNumber, setSkipNumber] = useState(0);
  const [loadMoreDisabled, setLoadMoreDisabled] = useAsyncSafeState(false);

  useEffect(() => {
    getStoreActivity(storeGuid, skipNumber).then((data) => {
      if (data.length) {
        setActivity((prevData) => [...prevData, ...data]);
      } else {
        setLoadMoreDisabled(true);
      }
    });
  }, [storeGuid, skipNumber, setActivity, setLoadMoreDisabled]);

  const loadMore = useCallback(() => setSkipNumber((prevSkip) => prevSkip + NUMBER_OF_ACTIVITY_EVENTS_TO_LOAD), [setSkipNumber]);

  return (
    <div className={style['tab-content']}>
      <div className={style['activity-table']}>
        <div className={style.header}>
          <FormattedMessage {...messages.storeActivity} />
        </div>
        {activity.map((instance, idx) => (
          <ActivityInstance key={idx} instance={instance} />
        ))}
        <div className={style['load-more']}>
          {loadMoreDisabled && (
            <FormattedMessage
              defaultMessage='No more activity to load.'
              description='Store settings activity page - load more disabled'
              id='sHKNhp'
            />
          )}
          {!loadMoreDisabled && (
            <Button disabled={loadMoreDisabled} onClick={loadMore} theme='link'>
              <FormattedMessage {...messages.loadMore} />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

ActivityTab.propTypes = {
  storeGuid: PropTypes.string.isRequired,
};

export default ActivityTab;
